import { Component, Input } from '@angular/core';

/**
 * Eine Komponente, die Ein Tooltip-Wrapper darstellt.
 */
@Component({
    selector: 'common-form-input-tooltip',
    template: `
        <div *ngIf="value" class="infoTooltip" [commonTooltip]="value">
            <button type="button" ibtn="info" ibtnTooltip [attr.aria-label]="value"></button>
        </div>`
})
export class FormButtonTooltipComponent {
    @Input() value: string;
}
